import { AuthContext as e, AuthorizedApiBase as t } from "@urbanx/agx.auth.client";
import n from "axios";
import { c as r } from "react/compiler-runtime";
import { jsx as i } from "react/jsx-runtime";
import { createContext as a, useContext as o, useEffect as s, useState as c } from "react";
import { useMutation as l, useQuery as u, useQueryClient as d } from "@tanstack/react-query";
//#region src/Client.ts
function f(e) {
	return e instanceof Date ? e.toISOString() : String(e);
}
var p = class extends t {
	instance;
	baseUrl;
	jsonParseReviver;
	constructor(e, t) {
		super(), this.instance = t ?? n.create(), this.baseUrl = e ?? "http://127.0.0.1:7071/agencies";
	}
	assignStaffMemberToAgencies(e, t) {
		let r = this.baseUrl + "/AssignStaffMemberToAgencies", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processAssignStaffMemberToAgencies(e)));
	}
	processAssignStaffMemberToAgencies(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 ? H("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : H("An unexpected server error occurred.", e.status, e.data, t);
	}
	createAgency(e, t) {
		let r = this.baseUrl + "/CreateAgency", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processCreateAgency(e)));
	}
	processCreateAgency(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 ? H("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : H("An unexpected server error occurred.", e.status, e.data, t);
	}
	createAgent(e, t) {
		let r = this.baseUrl + "/CreateAgent", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processCreateAgent(e)));
	}
	processCreateAgent(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 ? H("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : H("An unexpected server error occurred.", e.status, e.data, t);
	}
	deleteAgencySupplier(e, t) {
		let r = this.baseUrl + "/DeleteAgencySupplier", i = {
			method: "PUT",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processDeleteAgencySupplier(e)));
	}
	processDeleteAgencySupplier(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 ? H("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : H("An unexpected server error occurred.", e.status, e.data, t);
	}
	deleteDemoBrand(e, t) {
		let r = this.baseUrl + "/DeleteDemoBrand", i = {
			method: "DELETE",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processDeleteDemoBrand(e)));
	}
	processDeleteDemoBrand(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? H("Payload of String", e.status, e.data, t, e.data) : e.status === 401 || e.status === 403 ? H("No description", e.status, e.data, t) : e.status === 404 || e.status === 412 ? H("Payload of String", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : H("An unexpected server error occurred.", e.status, e.data, t);
	}
	getAgenciesAssignedToStaffMember(e, t) {
		let r = this.baseUrl + "/GetAgenciesAssignedToStaffMember", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetAgenciesAssignedToStaffMember(e)));
	}
	processGetAgenciesAssignedToStaffMember(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? H("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : H("An unexpected server error occurred.", e.status, e.data, t);
	}
	getAgencyDetails(e, t) {
		let r = this.baseUrl + "/GetAgencyDetails";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		r += "agencyId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetAgencyDetails(e)));
	}
	processGetAgencyDetails(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 204 ? Promise.resolve(null) : H("An unexpected server error occurred.", e.status, e.data, t);
	}
	getAgencyInformationForUser(e) {
		let t = this.baseUrl + "/GetAgencyInformationForUser", r = {
			method: "GET",
			url: t,
			headers: { Accept: "application/json" },
			signal: e
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(t, e, (e) => this.processGetAgencyInformationForUser(e)));
	}
	processGetAgencyInformationForUser(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 || e.status === 404 ? H("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : H("An unexpected server error occurred.", e.status, e.data, t);
	}
	getAgencyMembers(e, t) {
		let r = this.baseUrl + "/GetAgencyMembers";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		r += "agencyId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetAgencyMembers(e)));
	}
	processGetAgencyMembers(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 ? H("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : H("An unexpected server error occurred.", e.status, e.data, t);
	}
	getAgencySuppliers(e, t) {
		let r = this.baseUrl + "/GetAgencySuppliers";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		r += "agencyId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetAgencySuppliers(e)));
	}
	processGetAgencySuppliers(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 ? H("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : H("An unexpected server error occurred.", e.status, e.data, t);
	}
	getAgentProfile(e) {
		let t = this.baseUrl + "/GetAgentProfile", r = {
			method: "GET",
			url: t,
			headers: { Accept: "application/json" },
			signal: e
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(t, e, (e) => this.processGetAgentProfile(e)));
	}
	processGetAgentProfile(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 401 ? H("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : H("An unexpected server error occurred.", e.status, e.data, t);
	}
	getAgentsInAgency(e) {
		let t = this.baseUrl + "/GetAgentsInAgency", r = {
			method: "GET",
			url: t,
			headers: { Accept: "application/json" },
			signal: e
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(t, e, (e) => this.processGetAgentsInAgency(e)));
	}
	processGetAgentsInAgency(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 ? H("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : H("An unexpected server error occurred.", e.status, e.data, t);
	}
	getAllAgencies(e) {
		let t = this.baseUrl + "/GetAllAgencies", r = {
			method: "GET",
			url: t,
			headers: { Accept: "application/json" },
			signal: e
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(t, e, (e) => this.processGetAllAgencies(e)));
	}
	processGetAllAgencies(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 ? H("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : H("An unexpected server error occurred.", e.status, e.data, t);
	}
	getAllUsersInformation(e) {
		let t = this.baseUrl + "/GetAllUsersInformation", r = {
			method: "GET",
			url: t,
			headers: { Accept: "application/json" },
			signal: e
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(t, e, (e) => this.processGetAllUsersInformation(e)));
	}
	processGetAllUsersInformation(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 204 ? Promise.resolve(null) : H("An unexpected server error occurred.", e.status, e.data, t);
	}
	getAutopilotEntityDetails(e) {
		let t = this.baseUrl + "/GetAutopilotEntityDetails", r = {
			method: "GET",
			url: t,
			headers: { Accept: "application/json" },
			signal: e
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(t, e, (e) => this.processGetAutopilotEntityDetails(e)));
	}
	processGetAutopilotEntityDetails(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 ? H("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : H("An unexpected server error occurred.", e.status, e.data, t);
	}
	getBranding(e, t) {
		let r = this.baseUrl + "/GetBranding";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		r += "agencyId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetBranding(e)));
	}
	processGetBranding(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 ? H("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : H("An unexpected server error occurred.", e.status, e.data, t);
	}
	getCommissionSettings(e, t) {
		let r = this.baseUrl + "/GetCommissionSettings";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		r += "agencyId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetCommissionSettings(e)));
	}
	processGetCommissionSettings(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 || e.status === 404 ? H("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : H("An unexpected server error occurred.", e.status, e.data, t);
	}
	getContractSettings(e, t) {
		let r = this.baseUrl + "/GetContractSettings";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		r += "agencyId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetContractSettings(e)));
	}
	processGetContractSettings(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 || e.status === 404 ? H("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : H("An unexpected server error occurred.", e.status, e.data, t);
	}
	getDemoBrandColours(e, t, r) {
		let i = this.baseUrl + "/GetDemoBrandColours";
		if (i += "?", e == null) throw new globalThis.Error("The parameter 'mainColour' must be defined and cannot be null.");
		if (i += "mainColour=" + encodeURIComponent(f(e)) + "&", t == null) throw new globalThis.Error("The parameter 'accentColour' must be defined and cannot be null.");
		i += "accentColour=" + encodeURIComponent(f(t)) + "&", i = i.replace(/[?&]$/, "");
		let a = {
			method: "GET",
			url: i,
			headers: { Accept: "application/json" },
			signal: r
		};
		return this.transformOptions(a).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(i, e, (e) => this.processGetDemoBrandColours(e)));
	}
	processGetDemoBrandColours(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? H("Payload of Array of string", e.status, e.data, t, e.data) : e.status === 401 || e.status === 403 ? H("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : H("An unexpected server error occurred.", e.status, e.data, t);
	}
	getDemoBrands(e) {
		let t = this.baseUrl + "/GetDemoBrands", r = {
			method: "GET",
			url: t,
			headers: { Accept: "application/json" },
			signal: e
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(t, e, (e) => this.processGetDemoBrands(e)));
	}
	processGetDemoBrands(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? H("Payload of String", e.status, e.data, t, e.data) : e.status === 401 || e.status === 403 ? H("No description", e.status, e.data, t) : e.status === 404 ? H("Payload of String", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : H("An unexpected server error occurred.", e.status, e.data, t);
	}
	getEntityGoals(e) {
		let t = this.baseUrl + "/GetEntityGoals", r = {
			method: "GET",
			url: t,
			headers: { Accept: "application/json" },
			signal: e
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(t, e, (e) => this.processGetEntityGoals(e)));
	}
	processGetEntityGoals(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 ? H("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : H("An unexpected server error occurred.", e.status, e.data, t);
	}
	getExecutiveKeyBudget(e) {
		let t = this.baseUrl + "/GetExecutiveKeyBudget", r = {
			method: "GET",
			url: t,
			headers: { Accept: "application/json" },
			signal: e
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(t, e, (e) => this.processGetExecutiveKeyBudget(e)));
	}
	processGetExecutiveKeyBudget(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 ? H("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : H("An unexpected server error occurred.", e.status, e.data, t);
	}
	getFeatureToggles(e) {
		let t = this.baseUrl + "/GetFeatureToggles", r = {
			method: "GET",
			url: t,
			headers: { Accept: "application/json" },
			signal: e
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(t, e, (e) => this.processGetFeatureToggles(e)));
	}
	processGetFeatureToggles(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 401 ? H("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : H("An unexpected server error occurred.", e.status, e.data, t);
	}
	getLabGroupAgencyCode(e, t) {
		let r = this.baseUrl + "/GetLabGroupAgencyCode";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		r += "agencyId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetLabGroupAgencyCode(e)));
	}
	processGetLabGroupAgencyCode(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 || e.status === 404 ? H("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : H("An unexpected server error occurred.", e.status, e.data, t);
	}
	getListingAgreementSettings(e, t) {
		let r = this.baseUrl + "/GetListingAgreementSettings";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		r += "agencyId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetListingAgreementSettings(e)));
	}
	processGetListingAgreementSettings(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 || e.status === 404 ? H("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : H("An unexpected server error occurred.", e.status, e.data, t);
	}
	getPublicHolidays(e, t) {
		let r = this.baseUrl + "/GetPublicHolidays";
		if (r += "?", e === null) throw new globalThis.Error("The parameter 'state' cannot be null.");
		e !== void 0 && (r += "state=" + encodeURIComponent(f(e)) + "&"), r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetPublicHolidays(e)));
	}
	processGetPublicHolidays(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 204 ? Promise.resolve(null) : H("An unexpected server error occurred.", e.status, e.data, t);
	}
	getStaffMembersAssignedToAgencies(e, t, r) {
		let i = this.baseUrl + "/GetStaffMembersAssignedToAgencies";
		if (i += "?", e == null) throw new globalThis.Error("The parameter 'role' must be defined and cannot be null.");
		if (i += "role=" + encodeURIComponent(f(e)) + "&", t === null) throw new globalThis.Error("The parameter 'agencyIds' cannot be null.");
		if (t !== void 0) for (let e of t) i += "agencyIds=" + encodeURIComponent(f(e)) + "&";
		i = i.replace(/[?&]$/, "");
		let a = {
			method: "GET",
			url: i,
			headers: { Accept: "application/json" },
			signal: r
		};
		return this.transformOptions(a).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(i, e, (e) => this.processGetStaffMembersAssignedToAgencies(e)));
	}
	processGetStaffMembersAssignedToAgencies(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 ? H("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : H("An unexpected server error occurred.", e.status, e.data, t);
	}
	getTeamsForAgency(e, t) {
		let r = this.baseUrl + "/GetTeamsForAgency";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		r += "agencyId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetTeamsForAgency(e)));
	}
	processGetTeamsForAgency(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 ? H("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : H("An unexpected server error occurred.", e.status, e.data, t);
	}
	getUploadedFileLink(e, t) {
		let r = this.baseUrl + "/GetUploadedFileLink";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'filePath' must be defined and cannot be null.");
		r += "filePath=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetUploadedFileLink(e)));
	}
	processGetUploadedFileLink(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 ? H("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : H("An unexpected server error occurred.", e.status, e.data, t);
	}
	getUrbanXTeamForAgency(e, t) {
		let r = this.baseUrl + "/GetUrbanXTeamForAgency";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		r += "agencyId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetUrbanXTeamForAgency(e)));
	}
	processGetUrbanXTeamForAgency(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 204 ? Promise.resolve(null) : H("An unexpected server error occurred.", e.status, e.data, t);
	}
	removeFile(e, t) {
		let r = this.baseUrl + "/RemoveFile", i = {
			method: "POST",
			url: r,
			headers: { "Content-Type": "application/json" },
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processRemoveFile(e)));
	}
	processRemoveFile(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(null) : e.status === 400 || e.status === 401 ? H("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : H("An unexpected server error occurred.", e.status, e.data, t);
	}
	removePublicDocument(e, t) {
		let r = this.baseUrl + "/RemovePublicDocument", i = {
			method: "POST",
			url: r,
			headers: { "Content-Type": "application/json" },
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processRemovePublicDocument(e)));
	}
	processRemovePublicDocument(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(null) : e.status === 400 || e.status === 401 ? H("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : H("An unexpected server error occurred.", e.status, e.data, t);
	}
	saveDemoBrand(e, t) {
		let r = this.baseUrl + "/SaveDemoBrand", i = {
			method: "PUT",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processSaveDemoBrand(e)));
	}
	processSaveDemoBrand(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? H("Payload of String", e.status, e.data, t, e.data) : e.status === 401 || e.status === 403 ? H("No description", e.status, e.data, t) : e.status === 404 || e.status === 409 || e.status === 412 ? H("Payload of String", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : H("An unexpected server error occurred.", e.status, e.data, t);
	}
	sendInvitationEmail(e, t) {
		let r = this.baseUrl + "/SendInvitationEmail", i = {
			method: "POST",
			url: r,
			headers: { "Content-Type": "application/json" },
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processSendInvitationEmail(e)));
	}
	processSendInvitationEmail(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 204 ? Promise.resolve(null) : e.status === 400 || e.status === 401 ? H("No description", e.status, e.data, t) : e.status === 200 ? Promise.resolve(null) : H("An unexpected server error occurred.", e.status, e.data, t);
	}
	setAgentDetails(e, t) {
		let r = this.baseUrl + "/SetAgentDetails", i = {
			method: "PUT",
			url: r,
			headers: { "Content-Type": "application/json" },
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processSetAgentDetails(e)));
	}
	processSetAgentDetails(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(null) : e.status === 400 || e.status === 401 ? H("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : H("An unexpected server error occurred.", e.status, e.data, t);
	}
	setDemoBrand(e, t) {
		let r = this.baseUrl + "/SetDemoBrand", i = {
			method: "PUT",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processSetDemoBrand(e)));
	}
	processSetDemoBrand(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 ? H("Payload of String", e.status, e.data, t, e.data) : e.status === 401 || e.status === 403 ? H("No description", e.status, e.data, t) : e.status === 404 || e.status === 412 ? H("Payload of String", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : H("An unexpected server error occurred.", e.status, e.data, t);
	}
	setEntityGoals(e, t) {
		let r = this.baseUrl + "/SetEntityGoals", i = {
			method: "POST",
			url: r,
			headers: { "Content-Type": "application/json" },
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processSetEntityGoals(e)));
	}
	processSetEntityGoals(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(null) : e.status === 400 || e.status === 401 ? H("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : H("An unexpected server error occurred.", e.status, e.data, t);
	}
	setExecutiveKeyBudget(e, t) {
		let r = this.baseUrl + "/SetExecutiveKeyBudget", i = {
			method: "PUT",
			url: r,
			headers: { "Content-Type": "application/json" },
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processSetExecutiveKeyBudget(e)));
	}
	processSetExecutiveKeyBudget(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(null) : e.status === 400 || e.status === 401 ? H("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : H("An unexpected server error occurred.", e.status, e.data, t);
	}
	setTeamsForAgency(e, t) {
		let r = this.baseUrl + "/SetTeamsForAgency", i = {
			method: "PUT",
			url: r,
			headers: { "Content-Type": "application/json" },
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processSetTeamsForAgency(e)));
	}
	processSetTeamsForAgency(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(null) : e.status === 400 ? H("Payload of SetTeamsForAgencyError", e.status, e.data, t, e.data) : e.status === 401 ? H("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : H("An unexpected server error occurred.", e.status, e.data, t);
	}
	setUrbanXTeamForAgency(e, t) {
		let r = this.baseUrl + "/SetUrbanXTeamForAgency", i = {
			method: "PUT",
			url: r,
			headers: { "Content-Type": "application/json" },
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processSetUrbanXTeamForAgency(e)));
	}
	processSetUrbanXTeamForAgency(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(null) : e.status === 400 || e.status === 401 ? H("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : H("An unexpected server error occurred.", e.status, e.data, t);
	}
	softDeleteAgent(e, t) {
		let r = this.baseUrl + "/SoftDeleteAgent", i = {
			method: "PUT",
			url: r,
			headers: { "Content-Type": "application/json" },
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processSoftDeleteAgent(e)));
	}
	processSoftDeleteAgent(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 204 ? Promise.resolve(null) : e.status === 400 || e.status === 401 || e.status === 404 ? H("No description", e.status, e.data, t) : e.status === 200 ? Promise.resolve(null) : H("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffGetAgentsInAgency(e, t) {
		let r = this.baseUrl + "/StaffGetAgentsInAgency";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		r += "agencyId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffGetAgentsInAgency(e)));
	}
	processStaffGetAgentsInAgency(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 ? H("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : H("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffGetAllAgents(e) {
		let t = this.baseUrl + "/StaffGetAllAgents", r = {
			method: "GET",
			url: t,
			headers: { Accept: "application/json" },
			signal: e
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(t, e, (e) => this.processStaffGetAllAgents(e)));
	}
	processStaffGetAllAgents(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 ? H("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : H("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffGetAnnualBusinessTargets(e, t) {
		let r = this.baseUrl + "/StaffGetAnnualBusinessTargets";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		r += "agencyId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffGetAnnualBusinessTargets(e)));
	}
	processStaffGetAnnualBusinessTargets(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 ? H("No description", e.status, e.data, t) : e.status === 404 ? H("Payload of String", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : H("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffGetFeatureToggleManagement(e) {
		let t = this.baseUrl + "/StaffGetFeatureToggleManagement", r = {
			method: "GET",
			url: t,
			headers: { Accept: "application/json" },
			signal: e
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(t, e, (e) => this.processStaffGetFeatureToggleManagement(e)));
	}
	processStaffGetFeatureToggleManagement(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 401 ? H("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : H("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffGetFeatureToggles(e, t) {
		let r = this.baseUrl + "/StaffGetFeatureToggles";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		r += "campaignId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffGetFeatureToggles(e)));
	}
	processStaffGetFeatureToggles(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 ? H("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : H("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffGetPartnershipDetailsForAgency(e, t) {
		let r = this.baseUrl + "/StaffGetPartnershipDetailsForAgency";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		r += "agencyId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffGetPartnershipDetailsForAgency(e)));
	}
	processStaffGetPartnershipDetailsForAgency(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 || e.status === 404 ? H("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : H("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffSetAnnualBusinessTargets(e, t) {
		let r = this.baseUrl + "/StaffSetAnnualBusinessTargets", i = {
			method: "POST",
			url: r,
			headers: { "Content-Type": "application/json" },
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffSetAnnualBusinessTargets(e)));
	}
	processStaffSetAnnualBusinessTargets(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(null) : e.status === 400 || e.status === 401 ? H("No description", e.status, e.data, t) : e.status === 404 ? H("Payload of String", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : H("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffSetPartnershipDetailsForAgency(e, t) {
		let r = this.baseUrl + "/StaffSetPartnershipDetailsForAgency", i = {
			method: "POST",
			url: r,
			headers: { "Content-Type": "application/json" },
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffSetPartnershipDetailsForAgency(e)));
	}
	processStaffSetPartnershipDetailsForAgency(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(null) : e.status === 400 || e.status === 401 || e.status === 404 ? H("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : H("An unexpected server error occurred.", e.status, e.data, t);
	}
	staffUpdateFeatureSetting(e, t) {
		let r = this.baseUrl + "/StaffUpdateFeatureSetting", i = {
			method: "PUT",
			url: r,
			headers: { "Content-Type": "application/json" },
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffUpdateFeatureSetting(e)));
	}
	processStaffUpdateFeatureSetting(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(null) : e.status === 400 || e.status === 401 || e.status === 409 ? H("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : H("An unexpected server error occurred.", e.status, e.data, t);
	}
	updateAgency(e, t) {
		let r = this.baseUrl + "/UpdateAgency", i = {
			method: "PUT",
			url: r,
			headers: { "Content-Type": "application/json" },
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processUpdateAgency(e)));
	}
	processUpdateAgency(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 || e.status === 204 ? Promise.resolve(null) : H("An unexpected server error occurred.", e.status, e.data, t);
	}
	updateAgencySuppliers(e, t) {
		let r = this.baseUrl + "/UpdateAgencySuppliers", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processUpdateAgencySuppliers(e)));
	}
	processUpdateAgencySuppliers(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 ? H("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : H("An unexpected server error occurred.", e.status, e.data, t);
	}
	updateAgentProfile(e, t) {
		let r = this.baseUrl + "/UpdateAgentProfile", i = {
			method: "PUT",
			url: r,
			headers: { "Content-Type": "application/json" },
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processUpdateAgentProfile(e)));
	}
	processUpdateAgentProfile(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(null) : e.status === 400 || e.status === 401 ? H("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : H("An unexpected server error occurred.", e.status, e.data, t);
	}
	updateAutopilotEntityDetails(e, t) {
		let r = this.baseUrl + "/UpdateAutopilotEntityDetails", i = {
			method: "PUT",
			url: r,
			headers: { "Content-Type": "application/json" },
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processUpdateAutopilotEntityDetails(e)));
	}
	processUpdateAutopilotEntityDetails(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(null) : e.status === 400 || e.status === 401 ? H("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : H("An unexpected server error occurred.", e.status, e.data, t);
	}
	updateBranding(e, t, r) {
		let i = this.baseUrl + "/UpdateBranding";
		if (i += "?", e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		i += "agencyId=" + encodeURIComponent(f(e)) + "&", i = i.replace(/[?&]$/, "");
		let a = JSON.stringify(t), o = {
			method: "PUT",
			url: i,
			headers: { "Content-Type": "application/json" },
			data: a,
			signal: r
		};
		return this.transformOptions(o).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(i, e, (e) => this.processUpdateBranding(e)));
	}
	processUpdateBranding(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(null) : e.status === 400 || e.status === 401 ? H("No description", e.status, e.data, t) : e.status === 409 || e.status === 412 ? H("Payload of String", e.status, e.data, t, e.data) : e.status === 204 ? Promise.resolve(null) : H("An unexpected server error occurred.", e.status, e.data, t);
	}
	updateCommissionSettings(e, t, r) {
		let i = this.baseUrl + "/UpdateCommissionSettings";
		if (i += "?", e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		i += "agencyId=" + encodeURIComponent(f(e)) + "&", i = i.replace(/[?&]$/, "");
		let a = JSON.stringify(t), o = {
			method: "PUT",
			url: i,
			headers: { "Content-Type": "application/json" },
			data: a,
			signal: r
		};
		return this.transformOptions(o).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(i, e, (e) => this.processUpdateCommissionSettings(e)));
	}
	processUpdateCommissionSettings(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(null) : e.status === 400 || e.status === 401 ? H("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : H("An unexpected server error occurred.", e.status, e.data, t);
	}
	updateContractSettings(e, t, r) {
		let i = this.baseUrl + "/UpdateContractSettings";
		if (i += "?", e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		i += "agencyId=" + encodeURIComponent(f(e)) + "&", i = i.replace(/[?&]$/, "");
		let a = JSON.stringify(t), o = {
			method: "PUT",
			url: i,
			headers: { "Content-Type": "application/json" },
			data: a,
			signal: r
		};
		return this.transformOptions(o).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(i, e, (e) => this.processUpdateContractSettings(e)));
	}
	processUpdateContractSettings(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(null) : e.status === 400 || e.status === 401 ? H("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : H("An unexpected server error occurred.", e.status, e.data, t);
	}
	updateLabGroupAgencyCode(e, t) {
		let r = this.baseUrl + "/UpdateLabGroupAgencyCode", i = {
			method: "POST",
			url: r,
			headers: { "Content-Type": "application/json" },
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processUpdateLabGroupAgencyCode(e)));
	}
	processUpdateLabGroupAgencyCode(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 || e.status === 204 ? Promise.resolve(null) : e.status === 400 || e.status === 401 || e.status === 404 ? H("No description", e.status, e.data, t) : H("An unexpected server error occurred.", e.status, e.data, t);
	}
	updateListingAgreementSettings(e, t, r) {
		let i = this.baseUrl + "/UpdateListingAgreementSettings";
		if (i += "?", e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		i += "agencyId=" + encodeURIComponent(f(e)) + "&", i = i.replace(/[?&]$/, "");
		let a = JSON.stringify(t), o = {
			method: "PUT",
			url: i,
			headers: { "Content-Type": "application/json" },
			data: a,
			signal: r
		};
		return this.transformOptions(o).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(i, e, (e) => this.processUpdateListingAgreementSettings(e)));
	}
	processUpdateListingAgreementSettings(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(null) : e.status === 400 || e.status === 401 ? H("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : H("An unexpected server error occurred.", e.status, e.data, t);
	}
	uploadAgentProfilePhoto(e, t) {
		let r = this.baseUrl + "/UploadAgentProfilePhoto", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processUploadAgentProfilePhoto(e)));
	}
	processUploadAgentProfilePhoto(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 ? H("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : H("An unexpected server error occurred.", e.status, e.data, t);
	}
	uploadDocument(e, t) {
		let r = this.baseUrl + "/UploadDocument", i = {
			method: "POST",
			url: r,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			data: JSON.stringify(e),
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processUploadDocument(e)));
	}
	processUploadDocument(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 ? H("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : H("An unexpected server error occurred.", e.status, e.data, t);
	}
	uploadPublicDocument(e, t) {
		let r = this.baseUrl + "/UploadPublicDocument";
		if (r += "?", e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		r += "agencyId=" + encodeURIComponent(f(e)) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "POST",
			url: r,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (n.isAxiosError(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processUploadPublicDocument(e)));
	}
	processUploadPublicDocument(e) {
		let t = Object.fromEntries(Object.entries(e.headers ?? {}).map(([e, t]) => [e, t]));
		return e.status === 200 ? Promise.resolve(e.data) : e.status === 400 || e.status === 401 ? H("No description", e.status, e.data, t) : e.status === 204 ? Promise.resolve(null) : H("An unexpected server error occurred.", e.status, e.data, t);
	}
}, m = /* @__PURE__ */ function(e) {
	return e.UrbanX = "UrbanX", e.Autopilot = "Autopilot", e;
}({}), h = /* @__PURE__ */ function(e) {
	return e.None = "None", e.RealEstateCertificate = "RealEstateCertificate", e.RealEstateLicence = "RealEstateLicence", e.Class1 = "Class1", e.Class2 = "Class2", e;
}({}), g = /* @__PURE__ */ function(e) {
	return e.UrbanX = "UrbanX", e.Autopilot = "Autopilot", e;
}({}), _ = /* @__PURE__ */ function(e) {
	return e.UrbanX = "UrbanX", e.Autopilot = "Autopilot", e;
}({}), v = /* @__PURE__ */ function(e) {
	return e.None = "None", e.RealEstateCertificate = "RealEstateCertificate", e.RealEstateLicence = "RealEstateLicence", e.Class1 = "Class1", e.Class2 = "Class2", e;
}({}), y = /* @__PURE__ */ function(e) {
	return e.QLDResidentialForm6 = "QLDResidentialForm6", e.NSWResidentialAgreement = "NSWResidentialAgreement", e.NSWRuralAgreement = "NSWRuralAgreement", e;
}({}), b = /* @__PURE__ */ function(e) {
	return e.ACT = "ACT", e.NSW = "NSW", e.NT = "NT", e.QLD = "QLD", e.SA = "SA", e.TAS = "TAS", e.WA = "WA", e.VIC = "VIC", e;
}({}), x = /* @__PURE__ */ function(e) {
	return e.Aruba = "Aruba", e.Afghanistan = "Afghanistan", e.Angola = "Angola", e.Anguilla = "Anguilla", e.AlandIslands = "AlandIslands", e.Albania = "Albania", e.Andorra = "Andorra", e.UnitedArabEmirates = "UnitedArabEmirates", e.Argentina = "Argentina", e.Armenia = "Armenia", e.AmericanSamoa = "AmericanSamoa", e.Antarctica = "Antarctica", e.FrenchSouthernTerritories = "FrenchSouthernTerritories", e.AntiguaAndBarbuda = "AntiguaAndBarbuda", e.Australia = "Australia", e.Austria = "Austria", e.Azerbaijan = "Azerbaijan", e.Burundi = "Burundi", e.Belgium = "Belgium", e.Benin = "Benin", e.BonaireSintEustatiusAndSaba = "BonaireSintEustatiusAndSaba", e.BurkinaFaso = "BurkinaFaso", e.Bangladesh = "Bangladesh", e.Bulgaria = "Bulgaria", e.Bahrain = "Bahrain", e.Bahamas = "Bahamas", e.BosniaAndHerzegovina = "BosniaAndHerzegovina", e.SaintBarthelemy = "SaintBarthelemy", e.Belarus = "Belarus", e.Belize = "Belize", e.Bermuda = "Bermuda", e.Bolivia = "Bolivia", e.Brazil = "Brazil", e.Barbados = "Barbados", e.Brunei = "Brunei", e.Bhutan = "Bhutan", e.BouvetIsland = "BouvetIsland", e.Botswana = "Botswana", e.CentralAfricanRepublic = "CentralAfricanRepublic", e.Canada = "Canada", e.CocosKeelingIslands = "CocosKeelingIslands", e.Switzerland = "Switzerland", e.Chile = "Chile", e.China = "China", e.IvoryCoast = "IvoryCoast", e.Cameroon = "Cameroon", e.DemocraticRepublicOfTheCongo = "DemocraticRepublicOfTheCongo", e.RepublicOfTheCongo = "RepublicOfTheCongo", e.CookIslands = "CookIslands", e.Colombia = "Colombia", e.Comoros = "Comoros", e.CapeVerde = "CapeVerde", e.CostaRica = "CostaRica", e.Cuba = "Cuba", e.Curacao = "Curacao", e.ChristmasIsland = "ChristmasIsland", e.CaymanIslands = "CaymanIslands", e.Cyprus = "Cyprus", e.CzechRepublic = "CzechRepublic", e.Germany = "Germany", e.Djibouti = "Djibouti", e.Dominica = "Dominica", e.Denmark = "Denmark", e.DominicanRepublic = "DominicanRepublic", e.Algeria = "Algeria", e.Ecuador = "Ecuador", e.Egypt = "Egypt", e.Eritrea = "Eritrea", e.WesternSahara = "WesternSahara", e.Spain = "Spain", e.Estonia = "Estonia", e.Ethiopia = "Ethiopia", e.Finland = "Finland", e.Fiji = "Fiji", e.FalklandIslands = "FalklandIslands", e.France = "France", e.FaroeIslands = "FaroeIslands", e.Micronesia = "Micronesia", e.Gabon = "Gabon", e.UnitedKingdom = "UnitedKingdom", e.Georgia = "Georgia", e.Guernsey = "Guernsey", e.Ghana = "Ghana", e.Gibraltar = "Gibraltar", e.Guinea = "Guinea", e.Guadeloupe = "Guadeloupe", e.Gambia = "Gambia", e.GuineaBissau = "GuineaBissau", e.EquatorialGuinea = "EquatorialGuinea", e.Greece = "Greece", e.Grenada = "Grenada", e.Greenland = "Greenland", e.Guatemala = "Guatemala", e.FrenchGuiana = "FrenchGuiana", e.Guam = "Guam", e.Guyana = "Guyana", e.HongKong = "HongKong", e.HeardIslandAndMcDonaldIslands = "HeardIslandAndMcDonaldIslands", e.Honduras = "Honduras", e.Croatia = "Croatia", e.Haiti = "Haiti", e.Hungary = "Hungary", e.Indonesia = "Indonesia", e.IsleOfMan = "IsleOfMan", e.India = "India", e.BritishIndianOceanTerritory = "BritishIndianOceanTerritory", e.Ireland = "Ireland", e.Iran = "Iran", e.Iraq = "Iraq", e.Iceland = "Iceland", e.Israel = "Israel", e.Italy = "Italy", e.Jamaica = "Jamaica", e.Jersey = "Jersey", e.Jordan = "Jordan", e.Japan = "Japan", e.Kazakhstan = "Kazakhstan", e.Kenya = "Kenya", e.Kyrgyzstan = "Kyrgyzstan", e.Cambodia = "Cambodia", e.Kiribati = "Kiribati", e.SaintKittsAndNevis = "SaintKittsAndNevis", e.SouthKorea = "SouthKorea", e.Kuwait = "Kuwait", e.Laos = "Laos", e.Lebanon = "Lebanon", e.Liberia = "Liberia", e.Libya = "Libya", e.SaintLucia = "SaintLucia", e.Liechtenstein = "Liechtenstein", e.SriLanka = "SriLanka", e.Lesotho = "Lesotho", e.Lithuania = "Lithuania", e.Luxembourg = "Luxembourg", e.Latvia = "Latvia", e.Macau = "Macau", e.SaintMartin = "SaintMartin", e.Morocco = "Morocco", e.Monaco = "Monaco", e.Moldova = "Moldova", e.Madagascar = "Madagascar", e.Maldives = "Maldives", e.Mexico = "Mexico", e.MarshallIslands = "MarshallIslands", e.NorthMacedonia = "NorthMacedonia", e.Mali = "Mali", e.Malta = "Malta", e.Myanmar = "Myanmar", e.Montenegro = "Montenegro", e.Mongolia = "Mongolia", e.NorthernMarianaIslands = "NorthernMarianaIslands", e.Mozambique = "Mozambique", e.Mauritania = "Mauritania", e.Montserrat = "Montserrat", e.Martinique = "Martinique", e.Mauritius = "Mauritius", e.Malawi = "Malawi", e.Malaysia = "Malaysia", e.Mayotte = "Mayotte", e.Namibia = "Namibia", e.NewCaledonia = "NewCaledonia", e.Niger = "Niger", e.NorfolkIsland = "NorfolkIsland", e.Nigeria = "Nigeria", e.Nicaragua = "Nicaragua", e.Niue = "Niue", e.Netherlands = "Netherlands", e.Norway = "Norway", e.Nepal = "Nepal", e.Nauru = "Nauru", e.NewZealand = "NewZealand", e.Oman = "Oman", e.Pakistan = "Pakistan", e.Panama = "Panama", e.Pitcairn = "Pitcairn", e.Peru = "Peru", e.Philippines = "Philippines", e.Palau = "Palau", e.PapuaNewGuinea = "PapuaNewGuinea", e.Poland = "Poland", e.PuertoRico = "PuertoRico", e.NorthKorea = "NorthKorea", e.Portugal = "Portugal", e.Paraguay = "Paraguay", e.Palestine = "Palestine", e.FrenchPolynesia = "FrenchPolynesia", e.Qatar = "Qatar", e.Reunion = "Reunion", e.Romania = "Romania", e.Russia = "Russia", e.Rwanda = "Rwanda", e.SaudiArabia = "SaudiArabia", e.Sudan = "Sudan", e.Senegal = "Senegal", e.Singapore = "Singapore", e.SouthGeorgiaAndTheSouthSandwichIslands = "SouthGeorgiaAndTheSouthSandwichIslands", e.SaintHelena = "SaintHelena", e.SvalbardAndJanMayen = "SvalbardAndJanMayen", e.SolomonIslands = "SolomonIslands", e.SierraLeone = "SierraLeone", e.ElSalvador = "ElSalvador", e.SanMarino = "SanMarino", e.Somalia = "Somalia", e.SaintPierreAndMiquelon = "SaintPierreAndMiquelon", e.Serbia = "Serbia", e.SouthSudan = "SouthSudan", e.SaoTomeAndPrincipe = "SaoTomeAndPrincipe", e.Suriname = "Suriname", e.Slovakia = "Slovakia", e.Slovenia = "Slovenia", e.Sweden = "Sweden", e.Swaziland = "Swaziland", e.SintMaarten = "SintMaarten", e.Seychelles = "Seychelles", e.Syria = "Syria", e.TurksAndCaicosIslands = "TurksAndCaicosIslands", e.Chad = "Chad", e.Togo = "Togo", e.Thailand = "Thailand", e.Tajikistan = "Tajikistan", e.Tokelau = "Tokelau", e.Turkmenistan = "Turkmenistan", e.EastTimor = "EastTimor", e.Tonga = "Tonga", e.TrinidadAndTobago = "TrinidadAndTobago", e.Tunisia = "Tunisia", e.Turkey = "Turkey", e.Tuvalu = "Tuvalu", e.Taiwan = "Taiwan", e.Tanzania = "Tanzania", e.Uganda = "Uganda", e.Ukraine = "Ukraine", e.UnitedStatesMinorOutlyingIslands = "UnitedStatesMinorOutlyingIslands", e.Uruguay = "Uruguay", e.UnitedStates = "UnitedStates", e.Uzbekistan = "Uzbekistan", e.VaticanCity = "VaticanCity", e.SaintVincentAndTheGrenadines = "SaintVincentAndTheGrenadines", e.Venezuela = "Venezuela", e.BritishVirginIslands = "BritishVirginIslands", e.USVirginIslands = "USVirginIslands", e.Vietnam = "Vietnam", e.Vanuatu = "Vanuatu", e.WallisAndFutuna = "WallisAndFutuna", e.Samoa = "Samoa", e.Yemen = "Yemen", e.SouthAfrica = "SouthAfrica", e.Zambia = "Zambia", e.Zimbabwe = "Zimbabwe", e;
}({}), S = /* @__PURE__ */ function(e) {
	return e.ConfirmWithAgent = "ConfirmWithAgent", e.Original = "Original", e.Reduced = "Reduced", e;
}({}), C = /* @__PURE__ */ function(e) {
	return e.UnderOffer = "UnderOffer", e.Sold = "Sold", e.DoNotUpdate = "DoNotUpdate", e;
}({}), ee = /* @__PURE__ */ function(e) {
	return e.Available = "Available", e.UnderOffer = "UnderOffer", e;
}({}), te = /* @__PURE__ */ function(e) {
	return e.Connected = "Connected", e.PendingValidation = "PendingValidation", e;
}({}), w = /* @__PURE__ */ function(e) {
	return e.Rex = "Rex", e.Agentbox = "Agentbox", e.BoxAndDice = "BoxAndDice", e.Vault = "Vault", e;
}({}), T = /* @__PURE__ */ function(e) {
	return e.Connected = "Connected", e.PendingValidation = "PendingValidation", e;
}({}), E = /* @__PURE__ */ function(e) {
	return e.Connected = "Connected", e.PendingValidation = "PendingValidation", e;
}({}), D = /* @__PURE__ */ function(e) {
	return e.ACT = "ACT", e.NSW = "NSW", e.NT = "NT", e.QLD = "QLD", e.SA = "SA", e.TAS = "TAS", e.WA = "WA", e.VIC = "VIC", e;
}({}), O = /* @__PURE__ */ function(e) {
	return e.RPData = "RPData", e.RealEstateDotCom = "RealEstateDotCom", e.DomainDotCom = "DomainDotCom", e.DocuSign = "DocuSign", e.Rex = "Rex", e.CampaignFlow = "CampaignFlow", e;
}({}), k = /* @__PURE__ */ function(e) {
	return e.PurchaseTitleDocuments = "PurchaseTitleDocuments", e.RequestMarketingFunds = "RequestMarketingFunds", e.AutomateLiveListings = "AutomateLiveListings", e.SubmitListingToRex = "SubmitListingToRex", e.SubmitContractToRex = "SubmitContractToRex", e.HideLeaderBoardForLastFinancialYear = "HideLeaderBoardForLastFinancialYear", e.AutomateEmailListings = "AutomateEmailListings", e.AutomateEmailContracts = "AutomateEmailContracts", e.AssignCampaignFlowAdmin = "AssignCampaignFlowAdmin", e.EnableLaunchPad = "EnableLaunchPad", e.IdentityVerification = "IdentityVerification", e.CheckForExistingCrmListing = "CheckForExistingCrmListing", e.SubmitListingToCrm = "SubmitListingToCrm", e.AgentProfileSettings = "AgentProfileSettings", e.Proposals = "Proposals", e.E2EPlatformFeature = "E2EPlatformFeature", e.E2EQldFeature = "E2EQldFeature", e.E2EPlatformFeatureRetryOne = "E2EPlatformFeatureRetryOne", e.E2EQldFeatureRetryOne = "E2EQldFeatureRetryOne", e.E2EPlatformFeatureRetryTwo = "E2EPlatformFeatureRetryTwo", e.E2EQldFeatureRetryTwo = "E2EQldFeatureRetryTwo", e;
}({}), A = /* @__PURE__ */ function(e) {
	return e.Global = "Global", e.State = "State", e.Agency = "Agency", e.AgencyState = "AgencyState", e;
}({}), j = /* @__PURE__ */ function(e) {
	return e.ACT = "ACT", e.NSW = "NSW", e.NT = "NT", e.QLD = "QLD", e.SA = "SA", e.TAS = "TAS", e.WA = "WA", e.VIC = "VIC", e;
}({}), M = /* @__PURE__ */ function(e) {
	return e.Miscellaneous = "Miscellaneous", e.AgencyAgreement = "AgencyAgreement", e.MarketingAgreement = "MarketingAgreement", e.TitleSearch = "TitleSearch", e.BodyCorporateDisclosureStatement = "BodyCorporateDisclosureStatement", e.PoolCertificate = "PoolCertificate", e.NoticeOfMultipleOffers = "NoticeOfMultipleOffers", e.NoPoolCertificate = "NoPoolCertificate", e.AppointmentOfRealEstateAgent = "AppointmentOfRealEstateAgent", e.IntentToSell = "IntentToSell", e.SignedContract = "SignedContract", e.PowerOfAttorney = "PowerOfAttorney", e.WaiverOfCoolingOff = "WaiverOfCoolingOff", e.SalesContract = "SalesContract", e.SalesContractAnnexure = "SalesContractAnnexure", e.MergedAgencyAgreement = "MergedAgencyAgreement", e.MergedSalesContract = "MergedSalesContract", e.MaterialFact = "MaterialFact", e.ProofOfIdentity = "ProofOfIdentity", e.BlankSalesContract = "BlankSalesContract", e.AgencyAgreementAnnexure = "AgencyAgreementAnnexure", e.ConsumerGuide = "ConsumerGuide", e.OwnerBuilderDeclaration = "OwnerBuilderDeclaration", e.BlankSalesContractFlattened = "BlankSalesContractFlattened", e.AdditionalAnnexure = "AdditionalAnnexure", e.SalesAdvice = "SalesAdvice", e.ComparativeMarketAnalysis = "ComparativeMarketAnalysis", e.BuildingCertificate = "BuildingCertificate", e.SurveyPlan = "SurveyPlan", e.SellerDisclosure = "SellerDisclosure", e.BodyCorporateCertificate = "BodyCorporateCertificate", e.CommunityManagementStatement = "CommunityManagementStatement", e.DisclosureInstructions = "DisclosureInstructions", e.ListingPropertyImage = "ListingPropertyImage", e.ListingFloorPlan = "ListingFloorPlan", e.ExchangeLetter = "ExchangeLetter", e.VendorSettlementConfirmation = "VendorSettlementConfirmation", e.BuyerSettlementConfirmation = "BuyerSettlementConfirmation", e.PexaSettlementConfirmation = "PexaSettlementConfirmation", e.BuyerSolicitorEarlyDeposit = "BuyerSolicitorEarlyDeposit", e.VendorSolicitorEarlyDeposit = "VendorSolicitorEarlyDeposit", e.VendorTerminationConfirmation = "VendorTerminationConfirmation", e.BuyerTerminationConfirmation = "BuyerTerminationConfirmation", e.ContractExchange = "ContractExchange", e.WithdrawalConfirmation = "WithdrawalConfirmation", e.ProposalAttachment = "ProposalAttachment", e.ProposalAgencyFont = "ProposalAgencyFont", e.AdditionalSettlementCorrespondence = "AdditionalSettlementCorrespondence", e.AuthorityToExchange = "AuthorityToExchange", e.MergedContractExchange = "MergedContractExchange", e;
}({}), N = /* @__PURE__ */ function(e) {
	return e.ACT = "ACT", e.NSW = "NSW", e.NT = "NT", e.QLD = "QLD", e.SA = "SA", e.TAS = "TAS", e.WA = "WA", e.VIC = "VIC", e;
}({}), P = /* @__PURE__ */ function(e) {
	return e.Silver = "Silver", e.Gold = "Gold", e.Platinum = "Platinum", e.XPartner = "XPartner", e.Bronze = "Bronze", e;
}({}), F = /* @__PURE__ */ function(e) {
	return e.Silver = "Silver", e.Gold = "Gold", e.Platinum = "Platinum", e.XPartner = "XPartner", e.Bronze = "Bronze", e;
}({}), I = /* @__PURE__ */ function(e) {
	return e.AgentOrTeam = "AgentOrTeam", e.Agency = "Agency", e;
}({}), L = /* @__PURE__ */ function(e) {
	return e.ACT = "ACT", e.NSW = "NSW", e.NT = "NT", e.QLD = "QLD", e.SA = "SA", e.TAS = "TAS", e.WA = "WA", e.VIC = "VIC", e;
}({}), R = /* @__PURE__ */ function(e) {
	return e.UrbanX = "UrbanX", e.Autopilot = "Autopilot", e;
}({}), z = /* @__PURE__ */ function(e) {
	return e.Miscellaneous = "Miscellaneous", e.AgencyAgreement = "AgencyAgreement", e.MarketingAgreement = "MarketingAgreement", e.TitleSearch = "TitleSearch", e.BodyCorporateDisclosureStatement = "BodyCorporateDisclosureStatement", e.PoolCertificate = "PoolCertificate", e.NoticeOfMultipleOffers = "NoticeOfMultipleOffers", e.NoPoolCertificate = "NoPoolCertificate", e.AppointmentOfRealEstateAgent = "AppointmentOfRealEstateAgent", e.IntentToSell = "IntentToSell", e.SignedContract = "SignedContract", e.PowerOfAttorney = "PowerOfAttorney", e.WaiverOfCoolingOff = "WaiverOfCoolingOff", e.SalesContract = "SalesContract", e.SalesContractAnnexure = "SalesContractAnnexure", e.MergedAgencyAgreement = "MergedAgencyAgreement", e.MergedSalesContract = "MergedSalesContract", e.MaterialFact = "MaterialFact", e.ProofOfIdentity = "ProofOfIdentity", e.BlankSalesContract = "BlankSalesContract", e.AgencyAgreementAnnexure = "AgencyAgreementAnnexure", e.ConsumerGuide = "ConsumerGuide", e.OwnerBuilderDeclaration = "OwnerBuilderDeclaration", e.BlankSalesContractFlattened = "BlankSalesContractFlattened", e.AdditionalAnnexure = "AdditionalAnnexure", e.SalesAdvice = "SalesAdvice", e.ComparativeMarketAnalysis = "ComparativeMarketAnalysis", e.BuildingCertificate = "BuildingCertificate", e.SurveyPlan = "SurveyPlan", e.SellerDisclosure = "SellerDisclosure", e.BodyCorporateCertificate = "BodyCorporateCertificate", e.CommunityManagementStatement = "CommunityManagementStatement", e.DisclosureInstructions = "DisclosureInstructions", e.ListingPropertyImage = "ListingPropertyImage", e.ListingFloorPlan = "ListingFloorPlan", e.ExchangeLetter = "ExchangeLetter", e.VendorSettlementConfirmation = "VendorSettlementConfirmation", e.BuyerSettlementConfirmation = "BuyerSettlementConfirmation", e.PexaSettlementConfirmation = "PexaSettlementConfirmation", e.BuyerSolicitorEarlyDeposit = "BuyerSolicitorEarlyDeposit", e.VendorSolicitorEarlyDeposit = "VendorSolicitorEarlyDeposit", e.VendorTerminationConfirmation = "VendorTerminationConfirmation", e.BuyerTerminationConfirmation = "BuyerTerminationConfirmation", e.ContractExchange = "ContractExchange", e.WithdrawalConfirmation = "WithdrawalConfirmation", e.ProposalAttachment = "ProposalAttachment", e.ProposalAgencyFont = "ProposalAgencyFont", e.AdditionalSettlementCorrespondence = "AdditionalSettlementCorrespondence", e.AuthorityToExchange = "AuthorityToExchange", e.MergedContractExchange = "MergedContractExchange", e;
}({}), B = /* @__PURE__ */ function(e) {
	return e.RPData = "RPData", e.RealEstateDotCom = "RealEstateDotCom", e.DomainDotCom = "DomainDotCom", e.DocuSign = "DocuSign", e.Rex = "Rex", e.CampaignFlow = "CampaignFlow", e;
}({}), V = class extends Error {
	message;
	status;
	response;
	headers;
	result;
	constructor(e, t, n, r, i) {
		super(), this.message = e, this.status = t, this.response = n, this.headers = r, this.result = i;
	}
	isAgenciesApiException = !0;
	static isAgenciesApiException(e) {
		return e.isAgenciesApiException === !0;
	}
};
function H(e, t, n, r, i) {
	throw i ?? new V(e, t, n, r, null);
}
//#endregion
//#region src/useClientContext.tsx
var U = "agencies";
function W(e) {
	let t = Object.getPrototypeOf(e);
	for (let n of Object.getOwnPropertyNames(t)) {
		let r = t[n];
		typeof r == "function" && n !== "constructor" && (e[n] = r.bind(e));
	}
	return e;
}
var G = (e, t, n) => {
	let r = new p(e);
	return r.setAuthConfig(t, n), W(r);
}, K = ({ baseApiUri: e, localUris: t }) => {
	if (!e) throw console.error("Base API URI is undefined"), Error("Base API URI is undefined");
	return t?.[U] || `${e}/${U}`;
}, q = (t) => {
	let n = r(10), { agxConfig: i } = t, { getAuthToken: a } = o(e), l, u, d;
	n[0] !== i || n[1] !== a ? (l = K(i), u = c, d = G(l, a, i), n[0] = i, n[1] = a, n[2] = l, n[3] = u, n[4] = d) : (l = n[2], u = n[3], d = n[4]);
	let [f, p] = u(d), m, h;
	return n[5] !== i || n[6] !== l || n[7] !== a ? (m = () => {
		let e = G(l, a, i);
		p(e);
	}, h = [
		a,
		i,
		l
	], n[5] = i, n[6] = l, n[7] = a, n[8] = m, n[9] = h) : (m = n[8], h = n[9]), s(m, h), f;
}, J = a({}), Y = (e) => {
	let t = r(5), { appConfig: n, children: a } = e, o;
	t[0] === n ? o = t[1] : (o = { agxConfig: n }, t[0] = n, t[1] = o);
	let s = q(o);
	if (!s) return null;
	let c;
	return t[2] !== s || t[3] !== a ? (c = /* @__PURE__ */ i(J.Provider, {
		value: s,
		children: a
	}), t[2] = s, t[3] = a, t[4] = c) : c = t[4], c;
}, X = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(J), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.assignStaffMemberToAgencies(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		assignStaffMemberToAgencies: d,
		assignStaffMemberToAgenciesPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, Z = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(J), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.createAgency(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		createAgency: d,
		createAgencyPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, Q = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(J), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.createAgent(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		createAgent: d,
		createAgentPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, ne = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(J), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.deleteAgencySupplier(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		deleteAgencySupplier: d,
		deleteAgencySupplierPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, re = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(J), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.deleteDemoBrand(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		deleteDemoBrand: d,
		deleteDemoBrandPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, ie = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(J), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.getAgenciesAssignedToStaffMember(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		getAgenciesAssignedToStaffMember: d,
		getAgenciesAssignedToStaffMemberPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, ae = (e, t) => {
	let n = r(13), i = t === void 0 || t, a = o(J), s;
	n[0] === e ? s = n[1] : (s = ["getAgencyDetails", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== e || n[3] !== a ? (l = (t) => {
		let { signal: n } = t;
		return a.getAgencyDetails(e, n);
	}, n[2] = e, n[3] = a, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, oe = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getAgencyDetails", e] });
	}, e[0] = t, e[1] = n), n;
}, se = (e) => {
	let t = r(10), n = e === void 0 || e, i = o(J), a;
	t[0] === Symbol.for("react.memo_cache_sentinel") ? (a = ["getAgencyInformationForUser"], t[0] = a) : a = t[0];
	let s;
	t[1] === i ? s = t[2] : (s = (e) => {
		let { signal: t } = e;
		return i.getAgencyInformationForUser(t);
	}, t[1] = i, t[2] = s);
	let c = n && !!i, l;
	t[3] !== s || t[4] !== c ? (l = {
		queryKey: a,
		queryFn: s,
		enabled: c
	}, t[3] = s, t[4] = c, t[5] = l) : l = t[5];
	let { data: d, isPending: f, isError: p } = u(l), m;
	return t[6] !== d || t[7] !== p || t[8] !== f ? (m = {
		data: d,
		isPending: f,
		isError: p
	}, t[6] = d, t[7] = p, t[8] = f, t[9] = m) : m = t[9], m;
}, ce = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async () => {
		await t.invalidateQueries({ queryKey: ["getAgencyInformationForUser"] });
	}, e[0] = t, e[1] = n), n;
}, le = (e, t) => {
	let n = r(13), i = t === void 0 || t, a = o(J), s;
	n[0] === e ? s = n[1] : (s = ["getAgencyMembers", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== e || n[3] !== a ? (l = (t) => {
		let { signal: n } = t;
		return a.getAgencyMembers(e, n);
	}, n[2] = e, n[3] = a, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, ue = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getAgencyMembers", e] });
	}, e[0] = t, e[1] = n), n;
}, de = (e, t) => {
	let n = r(13), i = t === void 0 || t, a = o(J), s;
	n[0] === e ? s = n[1] : (s = ["getAgencySuppliers", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== e || n[3] !== a ? (l = (t) => {
		let { signal: n } = t;
		return a.getAgencySuppliers(e, n);
	}, n[2] = e, n[3] = a, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, fe = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getAgencySuppliers", e] });
	}, e[0] = t, e[1] = n), n;
}, pe = (e) => {
	let t = r(10), n = e === void 0 || e, i = o(J), a;
	t[0] === Symbol.for("react.memo_cache_sentinel") ? (a = ["getAgentProfile"], t[0] = a) : a = t[0];
	let s;
	t[1] === i ? s = t[2] : (s = (e) => {
		let { signal: t } = e;
		return i.getAgentProfile(t);
	}, t[1] = i, t[2] = s);
	let c = n && !!i, l;
	t[3] !== s || t[4] !== c ? (l = {
		queryKey: a,
		queryFn: s,
		enabled: c
	}, t[3] = s, t[4] = c, t[5] = l) : l = t[5];
	let { data: d, isPending: f, isError: p } = u(l), m;
	return t[6] !== d || t[7] !== p || t[8] !== f ? (m = {
		data: d,
		isPending: f,
		isError: p
	}, t[6] = d, t[7] = p, t[8] = f, t[9] = m) : m = t[9], m;
}, me = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async () => {
		await t.invalidateQueries({ queryKey: ["getAgentProfile"] });
	}, e[0] = t, e[1] = n), n;
}, he = (e) => {
	let t = r(10), n = e === void 0 || e, i = o(J), a;
	t[0] === Symbol.for("react.memo_cache_sentinel") ? (a = ["getAgentsInAgency"], t[0] = a) : a = t[0];
	let s;
	t[1] === i ? s = t[2] : (s = (e) => {
		let { signal: t } = e;
		return i.getAgentsInAgency(t);
	}, t[1] = i, t[2] = s);
	let c = n && !!i, l;
	t[3] !== s || t[4] !== c ? (l = {
		queryKey: a,
		queryFn: s,
		enabled: c
	}, t[3] = s, t[4] = c, t[5] = l) : l = t[5];
	let { data: d, isPending: f, isError: p } = u(l), m;
	return t[6] !== d || t[7] !== p || t[8] !== f ? (m = {
		data: d,
		isPending: f,
		isError: p
	}, t[6] = d, t[7] = p, t[8] = f, t[9] = m) : m = t[9], m;
}, ge = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async () => {
		await t.invalidateQueries({ queryKey: ["getAgentsInAgency"] });
	}, e[0] = t, e[1] = n), n;
}, _e = (e) => {
	let t = r(10), n = e === void 0 || e, i = o(J), a;
	t[0] === Symbol.for("react.memo_cache_sentinel") ? (a = ["getAllAgencies"], t[0] = a) : a = t[0];
	let s;
	t[1] === i ? s = t[2] : (s = (e) => {
		let { signal: t } = e;
		return i.getAllAgencies(t);
	}, t[1] = i, t[2] = s);
	let c = n && !!i, l;
	t[3] !== s || t[4] !== c ? (l = {
		queryKey: a,
		queryFn: s,
		enabled: c
	}, t[3] = s, t[4] = c, t[5] = l) : l = t[5];
	let { data: d, isPending: f, isError: p } = u(l), m;
	return t[6] !== d || t[7] !== p || t[8] !== f ? (m = {
		data: d,
		isPending: f,
		isError: p
	}, t[6] = d, t[7] = p, t[8] = f, t[9] = m) : m = t[9], m;
}, ve = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async () => {
		await t.invalidateQueries({ queryKey: ["getAllAgencies"] });
	}, e[0] = t, e[1] = n), n;
}, ye = (e) => {
	let t = r(10), n = e === void 0 || e, i = o(J), a;
	t[0] === Symbol.for("react.memo_cache_sentinel") ? (a = ["getAllUsersInformation"], t[0] = a) : a = t[0];
	let s;
	t[1] === i ? s = t[2] : (s = (e) => {
		let { signal: t } = e;
		return i.getAllUsersInformation(t);
	}, t[1] = i, t[2] = s);
	let c = n && !!i, l;
	t[3] !== s || t[4] !== c ? (l = {
		queryKey: a,
		queryFn: s,
		enabled: c
	}, t[3] = s, t[4] = c, t[5] = l) : l = t[5];
	let { data: d, isPending: f, isError: p } = u(l), m;
	return t[6] !== d || t[7] !== p || t[8] !== f ? (m = {
		data: d,
		isPending: f,
		isError: p
	}, t[6] = d, t[7] = p, t[8] = f, t[9] = m) : m = t[9], m;
}, be = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async () => {
		await t.invalidateQueries({ queryKey: ["getAllUsersInformation"] });
	}, e[0] = t, e[1] = n), n;
}, xe = (e) => {
	let t = r(10), n = e === void 0 || e, i = o(J), a;
	t[0] === Symbol.for("react.memo_cache_sentinel") ? (a = ["getAutopilotEntityDetails"], t[0] = a) : a = t[0];
	let s;
	t[1] === i ? s = t[2] : (s = (e) => {
		let { signal: t } = e;
		return i.getAutopilotEntityDetails(t);
	}, t[1] = i, t[2] = s);
	let c = n && !!i, l;
	t[3] !== s || t[4] !== c ? (l = {
		queryKey: a,
		queryFn: s,
		enabled: c
	}, t[3] = s, t[4] = c, t[5] = l) : l = t[5];
	let { data: d, isPending: f, isError: p } = u(l), m;
	return t[6] !== d || t[7] !== p || t[8] !== f ? (m = {
		data: d,
		isPending: f,
		isError: p
	}, t[6] = d, t[7] = p, t[8] = f, t[9] = m) : m = t[9], m;
}, Se = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async () => {
		await t.invalidateQueries({ queryKey: ["getAutopilotEntityDetails"] });
	}, e[0] = t, e[1] = n), n;
}, Ce = (e, t) => {
	let n = r(13), i = t === void 0 || t, a = o(J), s;
	n[0] === e ? s = n[1] : (s = ["getBranding", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== e || n[3] !== a ? (l = (t) => {
		let { signal: n } = t;
		return a.getBranding(e, n);
	}, n[2] = e, n[3] = a, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, we = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getBranding", e] });
	}, e[0] = t, e[1] = n), n;
}, Te = (e, t) => {
	let n = r(13), i = t === void 0 || t, a = o(J), s;
	n[0] === e ? s = n[1] : (s = ["getCommissionSettings", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== e || n[3] !== a ? (l = (t) => {
		let { signal: n } = t;
		return a.getCommissionSettings(e, n);
	}, n[2] = e, n[3] = a, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, Ee = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getCommissionSettings", e] });
	}, e[0] = t, e[1] = n), n;
}, De = (e, t) => {
	let n = r(13), i = t === void 0 || t, a = o(J), s;
	n[0] === e ? s = n[1] : (s = ["getContractSettings", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== e || n[3] !== a ? (l = (t) => {
		let { signal: n } = t;
		return a.getContractSettings(e, n);
	}, n[2] = e, n[3] = a, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, Oe = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getContractSettings", e] });
	}, e[0] = t, e[1] = n), n;
}, ke = (e, t, n) => {
	let i = r(15), a = n === void 0 || n, s = o(J), c;
	i[0] !== t || i[1] !== e ? (c = [
		"getDemoBrandColours",
		e,
		t
	], i[0] = t, i[1] = e, i[2] = c) : c = i[2];
	let l = c, d;
	i[3] !== t || i[4] !== s || i[5] !== e ? (d = (n) => {
		let { signal: r } = n;
		return s.getDemoBrandColours(e, t, r);
	}, i[3] = t, i[4] = s, i[5] = e, i[6] = d) : d = i[6];
	let f = a && !!s, p;
	i[7] !== l || i[8] !== d || i[9] !== f ? (p = {
		queryKey: l,
		queryFn: d,
		enabled: f
	}, i[7] = l, i[8] = d, i[9] = f, i[10] = p) : p = i[10];
	let { data: m, isPending: h, isError: g } = u(p), _;
	return i[11] !== m || i[12] !== g || i[13] !== h ? (_ = {
		data: m,
		isPending: h,
		isError: g
	}, i[11] = m, i[12] = g, i[13] = h, i[14] = _) : _ = i[14], _;
}, Ae = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e, n) => {
		await t.invalidateQueries({ queryKey: [
			"getDemoBrandColours",
			e,
			n
		] });
	}, e[0] = t, e[1] = n), n;
}, je = (e) => {
	let t = r(10), n = e === void 0 || e, i = o(J), a;
	t[0] === Symbol.for("react.memo_cache_sentinel") ? (a = ["getDemoBrands"], t[0] = a) : a = t[0];
	let s;
	t[1] === i ? s = t[2] : (s = (e) => {
		let { signal: t } = e;
		return i.getDemoBrands(t);
	}, t[1] = i, t[2] = s);
	let c = n && !!i, l;
	t[3] !== s || t[4] !== c ? (l = {
		queryKey: a,
		queryFn: s,
		enabled: c
	}, t[3] = s, t[4] = c, t[5] = l) : l = t[5];
	let { data: d, isPending: f, isError: p } = u(l), m;
	return t[6] !== d || t[7] !== p || t[8] !== f ? (m = {
		data: d,
		isPending: f,
		isError: p
	}, t[6] = d, t[7] = p, t[8] = f, t[9] = m) : m = t[9], m;
}, Me = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async () => {
		await t.invalidateQueries({ queryKey: ["getDemoBrands"] });
	}, e[0] = t, e[1] = n), n;
}, Ne = (e) => {
	let t = r(10), n = e === void 0 || e, i = o(J), a;
	t[0] === Symbol.for("react.memo_cache_sentinel") ? (a = ["getEntityGoals"], t[0] = a) : a = t[0];
	let s;
	t[1] === i ? s = t[2] : (s = (e) => {
		let { signal: t } = e;
		return i.getEntityGoals(t);
	}, t[1] = i, t[2] = s);
	let c = n && !!i, l;
	t[3] !== s || t[4] !== c ? (l = {
		queryKey: a,
		queryFn: s,
		enabled: c
	}, t[3] = s, t[4] = c, t[5] = l) : l = t[5];
	let { data: d, isPending: f, isError: p } = u(l), m;
	return t[6] !== d || t[7] !== p || t[8] !== f ? (m = {
		data: d,
		isPending: f,
		isError: p
	}, t[6] = d, t[7] = p, t[8] = f, t[9] = m) : m = t[9], m;
}, Pe = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async () => {
		await t.invalidateQueries({ queryKey: ["getEntityGoals"] });
	}, e[0] = t, e[1] = n), n;
}, Fe = (e) => {
	let t = r(10), n = e === void 0 || e, i = o(J), a;
	t[0] === Symbol.for("react.memo_cache_sentinel") ? (a = ["getExecutiveKeyBudget"], t[0] = a) : a = t[0];
	let s;
	t[1] === i ? s = t[2] : (s = (e) => {
		let { signal: t } = e;
		return i.getExecutiveKeyBudget(t);
	}, t[1] = i, t[2] = s);
	let c = n && !!i, l;
	t[3] !== s || t[4] !== c ? (l = {
		queryKey: a,
		queryFn: s,
		enabled: c
	}, t[3] = s, t[4] = c, t[5] = l) : l = t[5];
	let { data: d, isPending: f, isError: p } = u(l), m;
	return t[6] !== d || t[7] !== p || t[8] !== f ? (m = {
		data: d,
		isPending: f,
		isError: p
	}, t[6] = d, t[7] = p, t[8] = f, t[9] = m) : m = t[9], m;
}, Ie = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async () => {
		await t.invalidateQueries({ queryKey: ["getExecutiveKeyBudget"] });
	}, e[0] = t, e[1] = n), n;
}, Le = (e) => {
	let t = r(10), n = e === void 0 || e, i = o(J), a;
	t[0] === Symbol.for("react.memo_cache_sentinel") ? (a = ["getFeatureToggles"], t[0] = a) : a = t[0];
	let s;
	t[1] === i ? s = t[2] : (s = (e) => {
		let { signal: t } = e;
		return i.getFeatureToggles(t);
	}, t[1] = i, t[2] = s);
	let c = n && !!i, l;
	t[3] !== s || t[4] !== c ? (l = {
		queryKey: a,
		queryFn: s,
		enabled: c
	}, t[3] = s, t[4] = c, t[5] = l) : l = t[5];
	let { data: d, isPending: f, isError: p } = u(l), m;
	return t[6] !== d || t[7] !== p || t[8] !== f ? (m = {
		data: d,
		isPending: f,
		isError: p
	}, t[6] = d, t[7] = p, t[8] = f, t[9] = m) : m = t[9], m;
}, Re = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async () => {
		await t.invalidateQueries({ queryKey: ["getFeatureToggles"] });
	}, e[0] = t, e[1] = n), n;
}, ze = (e, t) => {
	let n = r(13), i = t === void 0 || t, a = o(J), s;
	n[0] === e ? s = n[1] : (s = ["getLabGroupAgencyCode", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== e || n[3] !== a ? (l = (t) => {
		let { signal: n } = t;
		return a.getLabGroupAgencyCode(e, n);
	}, n[2] = e, n[3] = a, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, Be = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getLabGroupAgencyCode", e] });
	}, e[0] = t, e[1] = n), n;
}, Ve = (e, t) => {
	let n = r(13), i = t === void 0 || t, a = o(J), s;
	n[0] === e ? s = n[1] : (s = ["getListingAgreementSettings", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== e || n[3] !== a ? (l = (t) => {
		let { signal: n } = t;
		return a.getListingAgreementSettings(e, n);
	}, n[2] = e, n[3] = a, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, He = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getListingAgreementSettings", e] });
	}, e[0] = t, e[1] = n), n;
}, Ue = (e, t) => {
	let n = r(13), i = t === void 0 || t, a = o(J), s;
	n[0] === e ? s = n[1] : (s = ["getPublicHolidays", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.getPublicHolidays(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, We = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getPublicHolidays", e] });
	}, e[0] = t, e[1] = n), n;
}, Ge = (e, t, n) => {
	let i = r(15), a = n === void 0 || n, s = o(J), c;
	i[0] !== t || i[1] !== e ? (c = [
		"getStaffMembersAssignedToAgencies",
		e,
		t
	], i[0] = t, i[1] = e, i[2] = c) : c = i[2];
	let l = c, d;
	i[3] !== t || i[4] !== s || i[5] !== e ? (d = (n) => {
		let { signal: r } = n;
		return s.getStaffMembersAssignedToAgencies(e, t, r);
	}, i[3] = t, i[4] = s, i[5] = e, i[6] = d) : d = i[6];
	let f = a && !!s, p;
	i[7] !== l || i[8] !== d || i[9] !== f ? (p = {
		queryKey: l,
		queryFn: d,
		enabled: f
	}, i[7] = l, i[8] = d, i[9] = f, i[10] = p) : p = i[10];
	let { data: m, isPending: h, isError: g } = u(p), _;
	return i[11] !== m || i[12] !== g || i[13] !== h ? (_ = {
		data: m,
		isPending: h,
		isError: g
	}, i[11] = m, i[12] = g, i[13] = h, i[14] = _) : _ = i[14], _;
}, Ke = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e, n) => {
		await t.invalidateQueries({ queryKey: [
			"getStaffMembersAssignedToAgencies",
			e,
			n
		] });
	}, e[0] = t, e[1] = n), n;
}, qe = (e, t) => {
	let n = r(13), i = t === void 0 || t, a = o(J), s;
	n[0] === e ? s = n[1] : (s = ["getTeamsForAgency", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== e || n[3] !== a ? (l = (t) => {
		let { signal: n } = t;
		return a.getTeamsForAgency(e, n);
	}, n[2] = e, n[3] = a, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, Je = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getTeamsForAgency", e] });
	}, e[0] = t, e[1] = n), n;
}, Ye = (e, t) => {
	let n = r(13), i = t === void 0 || t, a = o(J), s;
	n[0] === e ? s = n[1] : (s = ["getUploadedFileLink", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.getUploadedFileLink(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, Xe = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getUploadedFileLink", e] });
	}, e[0] = t, e[1] = n), n;
}, Ze = (e, t) => {
	let n = r(13), i = t === void 0 || t, a = o(J), s;
	n[0] === e ? s = n[1] : (s = ["getUrbanXTeamForAgency", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== e || n[3] !== a ? (l = (t) => {
		let { signal: n } = t;
		return a.getUrbanXTeamForAgency(e, n);
	}, n[2] = e, n[3] = a, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, Qe = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getUrbanXTeamForAgency", e] });
	}, e[0] = t, e[1] = n), n;
}, $e = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(J), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.removeFile(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		removeFile: d,
		removeFilePending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, et = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(J), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.removePublicDocument(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		removePublicDocument: d,
		removePublicDocumentPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, tt = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(J), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.saveDemoBrand(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		saveDemoBrand: d,
		saveDemoBrandPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, nt = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(J), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.sendInvitationEmail(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		sendInvitationEmail: d,
		sendInvitationEmailPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, rt = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(J), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.setAgentDetails(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		setAgentDetails: d,
		setAgentDetailsPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, it = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(J), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.setDemoBrand(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		setDemoBrand: d,
		setDemoBrandPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, at = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(J), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.setEntityGoals(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		setEntityGoals: d,
		setEntityGoalsPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, ot = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(J), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.setExecutiveKeyBudget(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		setExecutiveKeyBudget: d,
		setExecutiveKeyBudgetPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, st = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(J), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.setTeamsForAgency(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		setTeamsForAgency: d,
		setTeamsForAgencyPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, ct = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(J), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.setUrbanXTeamForAgency(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		setUrbanXTeamForAgency: d,
		setUrbanXTeamForAgencyPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, lt = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(J), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.softDeleteAgent(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		softDeleteAgent: d,
		softDeleteAgentPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, ut = (e, t) => {
	let n = r(13), i = t === void 0 || t, a = o(J), s;
	n[0] === e ? s = n[1] : (s = ["staffGetAgentsInAgency", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== e || n[3] !== a ? (l = (t) => {
		let { signal: n } = t;
		return a.staffGetAgentsInAgency(e, n);
	}, n[2] = e, n[3] = a, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, dt = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["staffGetAgentsInAgency", e] });
	}, e[0] = t, e[1] = n), n;
}, ft = (e) => {
	let t = r(10), n = e === void 0 || e, i = o(J), a;
	t[0] === Symbol.for("react.memo_cache_sentinel") ? (a = ["staffGetAllAgents"], t[0] = a) : a = t[0];
	let s;
	t[1] === i ? s = t[2] : (s = (e) => {
		let { signal: t } = e;
		return i.staffGetAllAgents(t);
	}, t[1] = i, t[2] = s);
	let c = n && !!i, l;
	t[3] !== s || t[4] !== c ? (l = {
		queryKey: a,
		queryFn: s,
		enabled: c
	}, t[3] = s, t[4] = c, t[5] = l) : l = t[5];
	let { data: d, isPending: f, isError: p } = u(l), m;
	return t[6] !== d || t[7] !== p || t[8] !== f ? (m = {
		data: d,
		isPending: f,
		isError: p
	}, t[6] = d, t[7] = p, t[8] = f, t[9] = m) : m = t[9], m;
}, pt = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async () => {
		await t.invalidateQueries({ queryKey: ["staffGetAllAgents"] });
	}, e[0] = t, e[1] = n), n;
}, mt = (e, t) => {
	let n = r(13), i = t === void 0 || t, a = o(J), s;
	n[0] === e ? s = n[1] : (s = ["staffGetAnnualBusinessTargets", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== e || n[3] !== a ? (l = (t) => {
		let { signal: n } = t;
		return a.staffGetAnnualBusinessTargets(e, n);
	}, n[2] = e, n[3] = a, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, ht = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["staffGetAnnualBusinessTargets", e] });
	}, e[0] = t, e[1] = n), n;
}, gt = (e) => {
	let t = r(10), n = e === void 0 || e, i = o(J), a;
	t[0] === Symbol.for("react.memo_cache_sentinel") ? (a = ["staffGetFeatureToggleManagement"], t[0] = a) : a = t[0];
	let s;
	t[1] === i ? s = t[2] : (s = (e) => {
		let { signal: t } = e;
		return i.staffGetFeatureToggleManagement(t);
	}, t[1] = i, t[2] = s);
	let c = n && !!i, l;
	t[3] !== s || t[4] !== c ? (l = {
		queryKey: a,
		queryFn: s,
		enabled: c
	}, t[3] = s, t[4] = c, t[5] = l) : l = t[5];
	let { data: d, isPending: f, isError: p } = u(l), m;
	return t[6] !== d || t[7] !== p || t[8] !== f ? (m = {
		data: d,
		isPending: f,
		isError: p
	}, t[6] = d, t[7] = p, t[8] = f, t[9] = m) : m = t[9], m;
}, _t = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async () => {
		await t.invalidateQueries({ queryKey: ["staffGetFeatureToggleManagement"] });
	}, e[0] = t, e[1] = n), n;
}, vt = (e, t) => {
	let n = r(13), i = t === void 0 || t, a = o(J), s;
	n[0] === e ? s = n[1] : (s = ["staffGetFeatureToggles", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.staffGetFeatureToggles(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, yt = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["staffGetFeatureToggles", e] });
	}, e[0] = t, e[1] = n), n;
}, bt = (e, t) => {
	let n = r(13), i = t === void 0 || t, a = o(J), s;
	n[0] === e ? s = n[1] : (s = ["staffGetPartnershipDetailsForAgency", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== e || n[3] !== a ? (l = (t) => {
		let { signal: n } = t;
		return a.staffGetPartnershipDetailsForAgency(e, n);
	}, n[2] = e, n[3] = a, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, xt = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["staffGetPartnershipDetailsForAgency", e] });
	}, e[0] = t, e[1] = n), n;
}, St = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(J), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.staffSetAnnualBusinessTargets(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		staffSetAnnualBusinessTargets: d,
		staffSetAnnualBusinessTargetsPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, Ct = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(J), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.staffSetPartnershipDetailsForAgency(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		staffSetPartnershipDetailsForAgency: d,
		staffSetPartnershipDetailsForAgencyPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, wt = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(J), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.staffUpdateFeatureSetting(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		staffUpdateFeatureSetting: d,
		staffUpdateFeatureSettingPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, Tt = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(J), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.updateAgency(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		updateAgency: d,
		updateAgencyPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, Et = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(J), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.updateAgencySuppliers(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		updateAgencySuppliers: d,
		updateAgencySuppliersPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, $ = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(J), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.updateAgentProfile(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		updateAgentProfile: d,
		updateAgentProfilePending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, Dt = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(J), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.updateAutopilotEntityDetails(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		updateAutopilotEntityDetails: d,
		updateAutopilotEntityDetailsPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, Ot = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(J), c;
	t[2] === s ? c = t[3] : (c = async (e) => {
		let { agencyId: t, body: n } = e;
		return s.updateBranding(t, n);
	}, t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		updateBranding: d,
		updateBrandingPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, kt = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(J), c;
	t[2] === s ? c = t[3] : (c = async (e) => {
		let { agencyId: t, body: n } = e;
		return s.updateCommissionSettings(t, n);
	}, t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		updateCommissionSettings: d,
		updateCommissionSettingsPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, At = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(J), c;
	t[2] === s ? c = t[3] : (c = async (e) => {
		let { agencyId: t, body: n } = e;
		return s.updateContractSettings(t, n);
	}, t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		updateContractSettings: d,
		updateContractSettingsPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, jt = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(J), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.updateLabGroupAgencyCode(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		updateLabGroupAgencyCode: d,
		updateLabGroupAgencyCodePending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, Mt = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(J), c;
	t[2] === s ? c = t[3] : (c = async (e) => {
		let { agencyId: t, body: n } = e;
		return s.updateListingAgreementSettings(t, n);
	}, t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		updateListingAgreementSettings: d,
		updateListingAgreementSettingsPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, Nt = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(J), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.uploadAgentProfilePhoto(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		uploadAgentProfilePhoto: d,
		uploadAgentProfilePhotoPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, Pt = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(J), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.uploadDocument(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		uploadDocument: d,
		uploadDocumentPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}, Ft = (e) => {
	let t = r(11), n;
	t[0] === e ? n = t[1] : (n = e === void 0 ? {} : e, t[0] = e, t[1] = n);
	let { onSuccess: i, onError: a } = n, s = o(J), c;
	t[2] === s ? c = t[3] : (c = async (e) => s.uploadPublicDocument(e), t[2] = s, t[3] = c);
	let u;
	t[4] !== a || t[5] !== i || t[6] !== c ? (u = {
		mutationFn: c,
		onSuccess: i,
		onError: a
	}, t[4] = a, t[5] = i, t[6] = c, t[7] = u) : u = t[7];
	let { mutateAsync: d, isPending: f } = l(u), p;
	return t[8] !== d || t[9] !== f ? (p = {
		uploadPublicDocument: d,
		uploadPublicDocumentPending: f
	}, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
};
//#endregion
export { J as AgenciesApiContext, V as AgenciesApiException, Y as AgenciesApiProvider, p as AgenciesClient, U as AgenciesRoute, m as AgencyAccountType, h as AgencyAgentModelLicenceType, g as AgencyDetailsModelAccountType, _ as AgencyInfoAccountType, v as AgentDetailsLicenceType, y as Agreements, b as ApplicableStates, x as AustralianPhoneNumberCallingCodeCountry, S as CommissionSettingsCommissionAdjustmentSalePriceReduced, C as ContractSettingsUnconditionalDisplayAs, ee as ContractSettingsUnderOfferDisplayAs, te as CrmAgentboxIntegrationSettingsConnectionStatus, w as CrmIntegrationSettingsActiveProvider, T as CrmRexIntegrationSettingsConnectionStatus, E as CrmVaultIntegrationSettingsConnectionStatus, D as CustomEmailParagraphState, O as ExternalIntegrations, k as Feature, A as FeatureConfigurationScopeLevel, j as FeatureConfigurationScopeState, M as FileUploadRequestDocumentType, N as LicenceDetailsState, P as PartnershipDetailsPartnershipLevel, F as PartnershipTierLevel, I as SetEntityGoalsRequestEntityType, L as States, R as UpdateAgencyDetailsAccountType, z as UploadedDocumentDocumentType, B as UserIntegrationAccessIntegration, q as useAgenciesClientContext, X as useAssignStaffMemberToAgencies, Z as useCreateAgency, Q as useCreateAgent, ne as useDeleteAgencySupplier, re as useDeleteDemoBrand, ie as useGetAgenciesAssignedToStaffMember, ae as useGetAgencyDetails, se as useGetAgencyInformationForUser, le as useGetAgencyMembers, de as useGetAgencySuppliers, pe as useGetAgentProfile, he as useGetAgentsInAgency, _e as useGetAllAgencies, ye as useGetAllUsersInformation, xe as useGetAutopilotEntityDetails, Ce as useGetBranding, Te as useGetCommissionSettings, De as useGetContractSettings, ke as useGetDemoBrandColours, je as useGetDemoBrands, Ne as useGetEntityGoals, Fe as useGetExecutiveKeyBudget, Le as useGetFeatureToggles, ze as useGetLabGroupAgencyCode, Ve as useGetListingAgreementSettings, Ue as useGetPublicHolidays, Ge as useGetStaffMembersAssignedToAgencies, qe as useGetTeamsForAgency, Ye as useGetUploadedFileLink, Ze as useGetUrbanXTeamForAgency, oe as useInvalidateUseGetAgencyDetails, ce as useInvalidateUseGetAgencyInformationForUser, ue as useInvalidateUseGetAgencyMembers, fe as useInvalidateUseGetAgencySuppliers, me as useInvalidateUseGetAgentProfile, ge as useInvalidateUseGetAgentsInAgency, ve as useInvalidateUseGetAllAgencies, be as useInvalidateUseGetAllUsersInformation, Se as useInvalidateUseGetAutopilotEntityDetails, we as useInvalidateUseGetBranding, Ee as useInvalidateUseGetCommissionSettings, Oe as useInvalidateUseGetContractSettings, Ae as useInvalidateUseGetDemoBrandColours, Me as useInvalidateUseGetDemoBrands, Pe as useInvalidateUseGetEntityGoals, Ie as useInvalidateUseGetExecutiveKeyBudget, Re as useInvalidateUseGetFeatureToggles, Be as useInvalidateUseGetLabGroupAgencyCode, He as useInvalidateUseGetListingAgreementSettings, We as useInvalidateUseGetPublicHolidays, Ke as useInvalidateUseGetStaffMembersAssignedToAgencies, Je as useInvalidateUseGetTeamsForAgency, Xe as useInvalidateUseGetUploadedFileLink, Qe as useInvalidateUseGetUrbanXTeamForAgency, dt as useInvalidateUseStaffGetAgentsInAgency, pt as useInvalidateUseStaffGetAllAgents, ht as useInvalidateUseStaffGetAnnualBusinessTargets, _t as useInvalidateUseStaffGetFeatureToggleManagement, yt as useInvalidateUseStaffGetFeatureToggles, xt as useInvalidateUseStaffGetPartnershipDetailsForAgency, $e as useRemoveFile, et as useRemovePublicDocument, tt as useSaveDemoBrand, nt as useSendInvitationEmail, rt as useSetAgentDetails, it as useSetDemoBrand, at as useSetEntityGoals, ot as useSetExecutiveKeyBudget, st as useSetTeamsForAgency, ct as useSetUrbanXTeamForAgency, lt as useSoftDeleteAgent, ut as useStaffGetAgentsInAgency, ft as useStaffGetAllAgents, mt as useStaffGetAnnualBusinessTargets, gt as useStaffGetFeatureToggleManagement, vt as useStaffGetFeatureToggles, bt as useStaffGetPartnershipDetailsForAgency, St as useStaffSetAnnualBusinessTargets, Ct as useStaffSetPartnershipDetailsForAgency, wt as useStaffUpdateFeatureSetting, Tt as useUpdateAgency, Et as useUpdateAgencySuppliers, $ as useUpdateAgentProfile, Dt as useUpdateAutopilotEntityDetails, Ot as useUpdateBranding, kt as useUpdateCommissionSettings, At as useUpdateContractSettings, jt as useUpdateLabGroupAgencyCode, Mt as useUpdateListingAgreementSettings, Nt as useUploadAgentProfilePhoto, Pt as useUploadDocument, Ft as useUploadPublicDocument };
